module.exports = __webpack_public_path__ + "img/1.95ec8cd6.png";